const AppConfig = {
  appName: 'ImpactBoard',
};

export default AppConfig;
